import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

const PARTNERS = [
  { name: 'Cemig', src: '/images/partners/cemig.png' },
  { name: 'Projemar', src: '/images/partners/projemar_telecom.png' },
  { name: 'Energisa', src: '/images/partners/grupo-energisa.svg' },
  // { name: 'Venge', src: '/images/partners/venge.svg' },
  // { name: 'Alhoha', src: '/images/partners/alhoha.svg' },
];

const AuthPartnersFooterV2 = () => (
  <Box sx={{ textAlign: 'center' }}>
    <Typography variant="caption" color="text.disabled" display="block" sx={{ mb: 1.5 }}>
      Parceiros
    </Typography>
    <Stack
      direction="row"
      flexWrap="wrap"
      useFlexGap
      spacing={2}
      alignItems="center"
      justifyContent="center"
    >
      {PARTNERS.map(partner => (
        <Box
          key={partner.name}
          component="img"
          src={partner.src}
          alt={partner.name}
          sx={{
            height: 33,
            width: 'auto',
            maxWidth: 90,
            objectFit: 'contain',
            opacity: 0.85,
          }}
        />
      ))}
    </Stack>
  </Box>
);

export default AuthPartnersFooterV2;
